import { api } from "@/lib/api";

export const DEFAULT_DIETARY_OPTIONS = [
  "Vegetarian",
  "Vegan",
  "Halal",
  "Kosher",
  "Dairy-free",
  "Gluten-free",
  "Nut allergy",
  "Low sodium",
];

export async function loadDietaryOptions() {
  try {
    const { data } = await api.get("/dietary-options");
    if (Array.isArray(data?.options) && data.options.length > 0) {
      return data.options;
    }
  } catch {
    // Keep the existing choices available while offline or during a transient outage.
  }
  return DEFAULT_DIETARY_OPTIONS;
}